import Req from '../../$axios';

const serviceModule = {
  // 模板列表
  saveOrUpdate(params) {
    return Req({
      url: 'taskAssociationDependency/saveOrUpdate',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 模板列表
  projectTaskForAssociationIndex(params) {
    return Req({
      url: 'tasks/projectTaskForAssociationIndex',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  //
  childrenTasksForAssociationIndex(params) {
    return Req({
      url: 'tasks/childrenTasksForAssociationIndex',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  cancelConnect(params) {
    return Req({
      url: 'taskAssociationDependency/cancel',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 连接线
  connectGantt(params) {
    return Req({
      url: 'taskAssociationDependency/save',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 获取清单进度
  getListTotalProgress(params) {
    return Req({
      url: 'tasklist/getListTotalProgress',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  }
}

export default {
  ...serviceModule
};
